import React, { useState } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

export default function Page({ children, totalFilesCount = 0  , title  }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 font-sans antialiased flex flex-col overflow-x-hidden" dir="rtl">
      <Navbar 
        onMenuClick={() => setIsSidebarOpen(true)} 
        totalFilesCount={totalFilesCount} 
        title = {title}
      />
      
      <Sidebar 
        isOpen={isSidebarOpen} 
        onClose={() => setIsSidebarOpen(false)} 
      />



      <main className="flex-1 max-w-4xl w-full mx-auto px-6 py-12 md:py-16 flex flex-col gap-8">
        {children}
      </main>
    </div>
  );
}